import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import classes from './LowerNavigation.module.css';
import {PRODUCTS} from '../../../URLS';
import {Link} from 'react-router-dom';

const LowerNavigation = ({collapsed, dropdowns, scrolled, cover}) => {
	return (
		<>
			{
                !collapsed && !Array.isArray(dropdowns) ?
                <Navbar bg="light" expand={true} className={`${scrolled ? 'no-cover-lower diverse' : ''} ${cover ? 'no-cover-lower' : ''}`}>
                  <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse>
                      <Nav className={classes.navigationContainer}>
                        {
                            Object.entries(dropdowns).map(([title, items], index) => {
                                const todosLink = PRODUCTS[title];
                                return  <NavDropdown title={title} id="basic-nav-dropdown"
                                             className={classes.dropdownHeader} key={index}>
                                             <Link to={todosLink} key={index+1000}>
                                              Todos
                                             </Link>
                                             {
                                                items.map((item, itemIndex) =>
                                                  <Link to={PRODUCTS[item]} key={itemIndex}>{item}</Link>)
                                             }
                                        </NavDropdown>
                                })
                        }
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>:null
            }
		</>
	)
}

export default LowerNavigation;
